import React, { useContext } from 'react';
import { _hex2rgba, _isIosDevice } from '../../utils/helpers';
import { AppContext } from '../../context/appData';

const Input = React.forwardRef((props, ref) => {
  const appData = useContext(AppContext);
  return (
    <React.Fragment>
      {props.label && (
        <label className="form__label">
          {props.label}
          {props.requiredStar ? (
            <span
              style={{ color: '#ff0505', paddingLeft: '1px', opacity: '0.7' }}
            >
              *
            </span>
          ) : (
            ''
          )}
        </label>
      )}
      <div
        style={{
          position: 'relative',
          width: props.width ? props.width : '',
        }}
        className="form__wrapper"
      >
        <input
          className="form__input"
          type={props.type}
          id={props.id || ''}
          spellCheck={props.spellCheck === false ? false : true}
          value={props.value}
          min={props.min}
          max={props.max}
          maxLength={props.maxLength ? props.maxLength : 64}
          minLength={props.minLength}
          name={props.name}
          placeholder={props.placeholder}
          onChange={props.changeInput || props.inputChange || props.onChange}
          required={props.required}
          disabled={props.loading || props.disabled}
          readOnly={props.disabled}
          autoComplete={props.autoComplete}
          {...(props.defaultValue && { defaultValue: props.defaultValue })}
          {...(props.autoFocus && { autoFocus: props.autoFocus })}
          {...(props.inputKeyPress && { onKeyPress: props.inputKeyPress })}
          {...(props.onKeyPress && { onKeyPress: props.onKeyPress })}
          {...(props.onKeyDown && { onKeyDown: props.onKeyDown })}
          {...(props.onKeyUp && { onKeyUp: props.onKeyUp })}
          {...(props.pattern && { pattern: props.pattern })}
          {...(props.inputMode && { inputMode: props.inputMode })}
          {...(props.inputBlur && { onBlur: props.inputBlur })}
          {...(props.onBlur && { onBlur: props.onBlur })}
          {...(props.onFocus && { onFocus: props.onFocus })}
          style={{
            padding:
              props.type !== 'color'
                ? props.size === 'tiny'
                  ? '1px 6px'
                  : props.size === 'small'
                  ? '6px 12px'
                  : // reduce padding on ios devices to compensate for 16px font size
                  _isIosDevice()
                  ? '10px 12px'
                  : ''
                : '',
            marginBottom: props.withMargin ? '20px' : '',
            marginTop: '0px',
            paddingLeft: props.withIcon
              ? '35px'
              : props.currency
              ? props.spacing
              : '',
            border: props.errorText
              ? '1px solid red'
              : props.successText
              ? '1px solid #5CB85C'
              : props.warningText
              ? '1px solid #ff9966'
              : '',
            /*
              use font size of 16px for input fields on ios devices to 
              prevent page zooming on input focus
            */
            borderRadius: props.borderRadius ? props.borderRadius : '',
            fontSize: _isIosDevice() ? '16px' : '',
          }}
          ref={ref}
        />
        {props.icon && (
          <span
            className="input-icon flex"
            style={{
              position: 'absolute',
              transform: 'translateY(-50%)',
              top: '50%',
              paddingLeft: '10px',
            }}
          >
            {props.icon}
          </span>
        )}
        {props.currency && (
          <span
            className="input-icon flex"
            style={{
              position: 'absolute',
              transform: 'translateY(-50%)',
              top: '50%',
              paddingLeft: '10px',
              fontSize: '12px',
            }}
          >
            {props.currency}
          </span>
        )}
        {props.passwordIcon && (
          <span
            className="input-icon flex"
            onClick={props.toggleInputType}
            style={{
              position: 'absolute',
              transform: 'translateY(-50%)',
              top: '50%',
              right: '10px',
              paddingRight: '10px',
              cursor: 'pointer',
            }}
          >
            {props.passwordIcon}
          </span>
        )}
        {props.errorText && (
          <span
            style={{
              position: 'absolute',
              fontSize: '11px',
              color: 'red',
              bottom: props.currency
                ? props.errorPosition
                  ? props.errorPosition
                  : '-17px'
                : '-17px',
            }}
          >
            {props.errorText}
          </span>
        )}
        {props.warningText && (
          <span
            style={{
              position: 'absolute',
              fontSize: '11px',
              color: '#ff9966',
              bottom: '-17px',
            }}
          >
            {props.warningText}
          </span>
        )}
        {props.successText && (
          <span
            style={{
              position: 'absolute',
              fontSize: '11px',
              color: '#5CB85C',
              bottom: props.currency ? '-17px' : '-17px',
            }}
          >
            {props.successText}
          </span>
        )}
        {props.loading && (
          <span
            className="loading-circle"
            style={{
              position: 'absolute',
              fontSize: '11px',
              color: '#5CB85C',
              transform: 'translateY(-50%)',
              top: 'calc(50% - 10px)',
              opacity: 0.6,
              right: '10px',
              borderTop: `1.5px solid ${_hex2rgba(appData.theme.color, 0.8)}`,
            }}
          ></span>
        )}
        {props.countLength && props.maxLength && (
          <span
            style={{
              position: 'absolute',
              fontSize: '9px',
              color: '#5e7079',
              bottom: '-14px',
              right: '0px',
            }}
          >
            {props.value.length} / {props.maxLength}
          </span>
        )}
      </div>
    </React.Fragment>
  );
});

export default Input;
